import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { LogOut, ShieldAlert, Smartphone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Logo } from "@/components/layout/Logo";
import { useAuthStore } from "@/lib/auth/store";

/**
 * Shown to authenticated non-SUPER_ADMIN accounts (restaurant staff).
 * This portal is platform-admin only — staff use the OSF app on their tablet.
 */
export default function Blocked() {
  const user = useAuthStore((s) => s.user);
  const logout = useAuthStore((s) => s.logout);
  const navigate = useNavigate();

  function handleLogout() {
    logout();
    navigate("/login", { replace: true });
  }

  return (
    <div className="relative flex min-h-screen items-center justify-center overflow-hidden bg-background">
      <div className="pointer-events-none absolute -right-32 -top-32 size-[420px] rounded-full bg-gradient-sunset opacity-30 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-40 -left-40 size-[420px] rounded-full bg-gradient-sunset opacity-20 blur-3xl" />

      <motion.div
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3, ease: "easeOut" }}
        className="relative w-full max-w-md px-6"
      >
        <div className="mb-6 flex justify-center">
          <Logo variant="full" className="block h-20" />
        </div>

        <Card className="shadow-xl">
          <CardContent className="flex flex-col items-center gap-4 p-8 text-center">
            <div className="flex h-16 w-16 items-center justify-center rounded-full bg-warning/10 text-warning">
              <ShieldAlert className="h-8 w-8" />
            </div>
            <div className="space-y-2">
              <h1 className="text-lg font-bold">
                Samahani{user ? `, ${user.fullName.split(/\s+/)[0]}` : ""}!
              </h1>
              <p className="text-sm text-muted-foreground">
                Portal hii ni ya wasimamizi wa mfumo — tumia OSF app kwenye tablet yako.
              </p>
              <p className="flex items-center justify-center gap-1.5 text-xs text-muted-foreground">
                <Smartphone className="h-3.5 w-3.5" />
                This portal is for platform administrators only. Please use the OSF app on your tablet.
              </p>
            </div>
            <Button variant="outline" onClick={handleLogout} className="mt-2">
              <LogOut className="h-4 w-4" /> Log out
            </Button>
          </CardContent>
        </Card>
      </motion.div>
    </div>
  );
}
